<template>
  <div class="system">系统</div>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/system/index.vue